import { useEffect, useRef, useState } from "react";
import { NavLink } from 'react-router-dom';
import { portfolioData } from "../Data/Database";
export function Sliders() {

  const carouselRef = useRef(null);
  const indicatorsRef = useRef(null);
  const itemsRef = useRef([]); // store created DOM nodes
  const [currentIndex, setCurrentIndex] = useState(0);

  // Create items & indicators once
  useEffect(() => {
    // initial layout
    updateCarouselStyles();

    // resize listener (debounce lightly)
    let resizeTimer = null;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateCarouselStyles, 120);
    };
    window.addEventListener('resize', handleResize);

    // cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimer);
    };
    // run only on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // update styles whenever index changes
  useEffect(() => {
    updateCarouselStyles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndex]);

  // helper functions
  const goToSlide = (index) => {
    setCurrentIndex(((index % portfolioData.length) + portfolioData.length) % portfolioData.length);
  };
  // const nextSlide = () => setCurrentIndex(prev => (prev + 1) % portfolioData.length);
  // const prevSlide = () => setCurrentIndex(prev => (prev - 1 + portfolioData.length) % portfolioData.length);

  // central function that only mutates styles of existing nodes
  const updateCarouselStyles = () => {
    const items = itemsRef.current;
    const totalItems = items.length;
    if (!items || totalItems === 0) return;

    const isMobile = window.innerWidth <= 768;
    const isTablet = window.innerWidth <= 1024;

    let spacing1 = 400, spacing2 = 600, spacing3 = 750;
    if (isMobile) {
      spacing1 = 280; spacing2 = 420; spacing3 = 550;
    } else if (isTablet) {
      spacing1 = 340; spacing2 = 520; spacing3 = 650;
    }

    items.forEach((item, index) => {
      let offset = index - currentIndex;
      if (offset > totalItems / 2) offset -= totalItems;
      if (offset < -totalItems / 2) offset += totalItems;
      const absOffset = Math.abs(offset);
      const sign = offset < 0 ? -1 : 1;

      item.style.transition = 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.6s ease';

      if (absOffset === 0) {
        item.style.transform = 'translate(-50%, -50%) translateZ(0) scale(1)';
        item.style.opacity = '1';
        item.style.zIndex = '10';
      } else if (absOffset === 1) {
        const translateX = sign * spacing1;
        const rotation = isMobile ? 25 : 30;
        const scale = isMobile ? 0.88 : 0.85;
        item.style.transform = `translate(-50%, -50%) translateX(${translateX}px) translateZ(-200px) rotateY(${-sign * rotation}deg) scale(${scale})`;
        item.style.opacity = '0.85';
        item.style.zIndex = '5';
      } else if (absOffset === 2) {
        const translateX = sign * spacing2;
        const rotation = isMobile ? 35 : 40;
        const scale = isMobile ? 0.75 : 0.7;
        item.style.transform = `translate(-50%, -50%) translateX(${translateX}px) translateZ(-350px) rotateY(${-sign * rotation}deg) scale(${scale})`;
        item.style.opacity = '0.5';
        item.style.zIndex = '3';
      } else if (absOffset === 3) {
        const translateX = sign * spacing3;
        const rotation = isMobile ? 40 : 45;
        const scale = isMobile ? 0.65 : 0.6;
        item.style.transform = `translate(-50%, -50%) translateX(${translateX}px) translateZ(-450px) rotateY(${-sign * rotation}deg) scale(${scale})`;
        item.style.opacity = '0.3';
        item.style.zIndex = '2';
      } else {
        item.style.transform = 'translate(-50%, -50%) translateZ(-500px) scale(0.5)';
        item.style.opacity = '0';
        item.style.zIndex = '1';
      }
    });

    // update indicators active state
    const indicators = indicatorsRef.current?.querySelectorAll('.indicator') || [];
    indicators.forEach((ind, i) => ind.classList.toggle('active', i === currentIndex));

  }
  const heroRef = useRef(null);
  useEffect(() => {
    const handleScroll = () => {
      // const scrolled = window.pageYOffset;
      if (heroRef.current) heroRef.current.style.transform = ``;
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <>
      <div className="parent-slider">
        {/* CAROUSEL */}
        <section className="hero" id="home">
          <div className="carousel-container" ref={heroRef}>
            <div className="carousel" id="carousel" ref={carouselRef}>
              {portfolioData.map((data, index) => (
                <div
                  key={data.id}
                  className="carousel-item"
                  data-index={index}
                  ref={(el) => (itemsRef.current[index] = el)}
                  style={{ transition: 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.6s ease, z-index 0s' }}
                >
                  <div className="card">
                    <div className="card-image">
                      <img src={data.image} alt={data.name} />
                    </div>
                    <h3 className="card-title">{data.name}</h3>
                    <p className="card-description">-{data.artist}</p>
                    <div className="card-tech">
                      {data.tech.map((tech) => (
                        <span key={tech} className="tech-badge">
                          {tech}
                        </span>
                      ))}
                    </div>
                    <NavLink
                      to="/painting"
                      state={{ painting: data }}
                    >
                      <button className="card-cta">
                        Explore
                      </button>
                    </NavLink>
                  </div>
                </div>
              ))}
            </div>
            <div className="carousel-indicators" id="indicators" ref={indicatorsRef}>
              {portfolioData.map((_, index) => (
                <div
                  key={index}
                  className={`indicator ${index === 0 ? 'active' : ''}`}
                  data-index={index}
                  onClick={() => goToSlide(index)}
                ></div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  )
}